// extracted by mini-css-extract-plugin
export var footer = "_nf-5";
export var fulfillmentInput = "_nf-0";
export var shipDateInput = "_nf-1";
export var shipmentModal = "_nf-2";
export var shipmentModalContent = "_nf-3";
export var tableContainer = "_nf-4";